// @ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import ReactPlayer from "react-player";
import { PlayCircle, PauseCircle, MoreVertical } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../hooks/useRedux";
import { BASE_URL } from "../Constants/BaseUrl";
import { useNavigate } from "react-router-dom";
import ReportModal from "./ReportModal";
import { fetchAllPublicPosts } from "../store/postsSlice";

const PostItem = ({
  item,
  onToggleLike,
  playing,
  setPlaying,
  fromSearchScreen,
  fromPostPreview,
}) => {
  const user = useAppSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isReported, setIsReported] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isVideo = !!item.video_url;
  const isPlaying = playing === item.post_id;

  // Check if the post is reported by the current user on mount
  useEffect(() => {
    if (user?.user_id) {
      const reportedPosts = JSON.parse(
        localStorage.getItem(`reportedPosts_${user.user_id}`) || "{}",
      );
      setIsReported(!!reportedPosts[item.post_id || item.id]);
    }
  }, [user?.user_id, item.post_id, item.id]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePlayToggle = () => {
    setPlaying(isPlaying ? null : item.post_id);
  };

  const handleMoreClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleReport = () => {
    setIsDropdownOpen(false);
    setIsReportModalOpen(true);
  };

  const handleReportModalClose = () => {
    setIsReportModalOpen(false);
  };

  const handleReportSubmitted = () => {
    if (user?.user_id) {
      const reportedPosts = JSON.parse(
        localStorage.getItem(`reportedPosts_${user.user_id}`) || "{}",
      );
      reportedPosts[item.post_id || item.id] = true;
      localStorage.setItem(
        `reportedPosts_${user.user_id}`,
        JSON.stringify(reportedPosts),
      );
      setIsReported(true);
      dispatch(fetchAllPublicPosts());
    }
    console.log("Report submitted successfully");
  };

  return (
    <div
      className={`bg-[#1e1e1e] text-white rounded-xl shadow-lg overflow-hidden mt-8 ${
        fromSearchScreen || fromPostPreview ? "w-11/13" : "w-11/12"
      }`}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-[#333]">
        <div
          onClick={() => {
            if (Number(item.user_id) !== Number(user?.user_id)) {
              if (item.role === "coach") {
                navigate("/coach-public-profile", {
                  state: {
                    user_id: item?.user_id,
                  },
                });
              } else if (item.role === "student-athlete") {
                navigate("/public-profile", {
                  state: {
                    user_id: item?.user_id,
                  },
                });
              }
            }
          }}
          className="flex items-center gap-4 cursor-pointer"
        >
          <img
            // src={
            //   item.profile_picture
            //     ? `${BASE_URL}${item.profile_picture}`
            //     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            // }
            src={
              item.profile_picture?.startsWith("https")
                ? item.profile_picture
                : item.profile_picture
                  ? `${BASE_URL}/${item.profile_picture}`
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            }
            alt="Profile"
            className="h-12 w-12 rounded-full object-cover border-2 border-red-600"
          />
          <div>
            <p className="font-semibold text-white text-sm">
              {item.first_name} {item.last_name}
            </p>
            <p className="text-xs text-gray-400">{item.created_at}</p>
          </div>
        </div>

        {/* MoreVertical Button and Dropdown */}
        {!isReported && (
          <div className="relative" ref={dropdownRef}>
            {user?.user_id !== item.user_id && (
              <button
                onClick={handleMoreClick}
                className="p-2 rounded-full hover:bg-gray-700 focus:outline-none"
                aria-label="More options"
              >
                <MoreVertical size={20} color="white" />
              </button>
            )}
            {isDropdownOpen && (
              <div className="absolute right-3 top-5 mt-2 w-32 bg-[#2a2a2a] rounded-md shadow-lg z-10">
                <button
                  onClick={handleReport}
                  className="block w-full px-4 py-2 text-sm text-white hover:bg-red-600 rounded-md text-center"
                >
                  Report
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Media */}
      <div className="relative w-full h-[500px] bg-black">
        {isReported ? (
          <div className="absolute inset-0 flex justify-center items-center bg-black/80 z-10">
            <p className="text-white text-lg font-semibold">
              This post has been reported and is under review.
            </p>
          </div>
        ) : (
          <>
            {isVideo ? (
              <>
                <ReactPlayer
                  // url={`${BASE_URL}${item.video_url}`}
                  url={
                    item.video_url?.startsWith("https")
                      ? item.video_url
                      : item.video_url
                        ? `${BASE_URL}/${item.video_url}`
                        : undefined
                  }
                  playing={isPlaying}
                  controls={false}
                  width="100%"
                  height="100%"
                  onReady={() => setLoading(false)}
                  onStart={() => setLoading(false)}
                  onEnded={() => setPlaying(null)}
                  onBuffer={() => setLoading(true)}
                  onBufferEnd={() => setLoading(false)}
                />
                {!loading && (
                  <button
                    className="absolute inset-0 flex justify-center items-center bg-black/40"
                    onClick={handlePlayToggle}
                  >
                    {isPlaying ? (
                      <PauseCircle size={64} color="white" />
                    ) : (
                      <PlayCircle size={64} color="white" />
                    )}
                  </button>
                )}
              </>
            ) : (
              <img
                // src={`${BASE_URL}${item.image_url}`}
                src={
                  item.image_url?.startsWith("https")
                    ? item.image_url
                    : item.image_url
                      ? `${BASE_URL}/${item.image_url}`
                      : undefined
                }
                alt="Post"
                className="w-full h-full object-contain"
              />
            )}
          </>
        )}
      </div>

      {/* Caption */}
      <div className="px-4 py-2">
        {isReported ? (
          <p className="text-sm text-gray-400 italic">
            Content hidden due to pending review.
          </p>
        ) : (
          <p className="text-sm text-gray-200">{item.content}</p>
        )}
      </div>

      {/* Like Button */}
      <div className="px-4 py-2">
        {!isReported && (
          <button
            className="text-lg text-red-500 hover:text-red-600"
            onClick={() => onToggleLike(item.post_id || item.id)}
            disabled={isReported}
          >
            {item.liked ? "♥" : "♡"} {item.like_count}
          </button>
        )}
      </div>

      {/* Report Modal */}
      <ReportModal
        visible={isReportModalOpen}
        onClose={handleReportModalClose}
        postId={item.post_id || item.id}
        userId={user?.user_id}
        onReport={handleReportSubmitted}
      />
    </div>
  );
};

export default PostItem;
